export default {"src":"/_next/static/media/happy_24.8f734815.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};